import ROUTES from "../utils/routes";
import {
  FourSquares,
  DownloadFile,
  EmptyClipBoard,
  BulletListPoint,
} from "../assets/icons";

export const masterData = {
  Administration: [
    {
      id: 1,
      name: "User",
      path: ROUTES.AUM,
      rolesCanAccess: ["system admin", "manager"],
      icon: <FourSquares />,
    },
    {
      id: 2,
      name: "Lock/Unlock",
      path: ROUTES.ALU,
      rolesCanAccess: ["system admin", "manager", "cc processor"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    {
      id: 3,
      name: "Allocation Status",
      path: "/Administration/AllocationStatus-Table",
      rolesCanAccess: ["system admin", "manager", "lead role", "cc processor"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    {
      id: 4,
      name: "Exchange Rate",
      path: "/Administration/BankExchange-Table",
      rolesCanAccess: ["system admin", "manager", "lead role", "cc processor"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    {
      id: 5,
      name: "Bank Information Table",
      path: "/Administration/Bank-Information-Table",
      rolesCanAccess: ["system admin", "manager", "lead role", "cc processor"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    {
      id: 6,
      name: "Binding Agreements",
      path: "/Administration/Binding-Agreement",
      rolesCanAccess: ["system admin", "manager", "lead role", "cc processor"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    {
      id: 7,
      name: "Broker Table",
      path: "/Administration/Broker-Table",
      rolesCanAccess: ["system admin", "manager", "lead role", "cc processor", "finance"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    {
      id: 8,
      name: " Correction Reason Table",
      path: "/Administration/CorrectionType-Table",
      rolesCanAccess: ["system admin", "manager", "lead role", "cc processor"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    // {
    //   id: 9,
    //   name: "Corrective Transfer",
    //   path: "/Administration/Corrective-Table",
    //   rolesCanAccess: ["system admin", "manager", "lead role", "cc processor"],
    //   icon: <BulletListPoint className="administration-icons" />,
    // },
    {
      id: 10,
      name: "Currency",
      path: "/Administration/Currency-Table",
      rolesCanAccess: ["system admin", "manager", "lead role", "cc processor"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    {
      id: 11,
      name: "Entity Table",
      path: "/Administration/Entity-Table",
      rolesCanAccess: ["system admin", "manager", "lead role", "cc processor"],
      icon: <DownloadFile className="administration-icons" />,
    },
    {
      id: 12,
      name: "LOB Table",
      path: "/Administration/LOB-Table",
      rolesCanAccess: ["system admin", "manager", "lead role", "cc processor"],
      icon: <EmptyClipBoard className="administration-icons" />,
    },
    {
      id: 13,
      name: "Policy",
      path: "/Administration/Policy-Table",
      rolesCanAccess: ["system admin", "manager", "lead role", "cc processor"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    {
      id: 14,
      name: "SCM Partners",
      path: "/Administration/SCM-Table",
      rolesCanAccess: ["system admin", "manager", "lead role", "cc processor"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    {
      id: 15,
      name: "SLA",
      path: "/Administration/SLA-Table",
      rolesCanAccess: ["system admin", "manager", "lead role"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    {
      id: 16,
      name: "Participating Insurers",
      path: "/Administration/Participating-Insurer-Table",
      rolesCanAccess: ["system admin", "manager", "lead role"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    {
      id: 17,
      name: "Escalation",
      path: "/Administration/Escalation-Table",
      rolesCanAccess: ["system admin", "manager", "lead role"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    {
      id: 18,
      name: "Txn Category",
      path: "/Administration/TxnCategory-Table",
      rolesCanAccess: ["system admin", "manager", "lead role"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    {
      id: 19,
      name: "Document Repository",
      path: "/Administration/File-Management",
      rolesCanAccess: ["system admin", "manager", "lead role"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    {
      id: 20,
      name: "Month End Closing Dates",
      path: ROUTES.BTAM,
      rolesCanAccess: ["system admin", "manager"],
      icon: <FourSquares />,
    },
    {
      id: 21,
      name: "Workflow User Management",
      path: "/Administration/Workflow-Table",
      rolesCanAccess: ["system admin", "manager", "lead role"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    {
      id: 22,
      name: "Transaction Status",
      path: "/Administration/TxnStatus-Table",
      rolesCanAccess: ["system admin", "manager", "lead role"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    {
      id: 23,
      name: "Chaser Indicator",
      path: "/Administration/Chaser-Indicator",
      rolesCanAccess: ["system admin", "manager", "lead role"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    {
      id: 24,
      name: "Agedebt Action",
      path: "/Administration/Agedebt-Action",
      rolesCanAccess: ["system admin", "manager", "lead role"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    {
      id: 25,
      name: "Agedebt Category",
      path: "/Administration/Agedebt-Category",
      rolesCanAccess: ["system admin", "manager", "lead role"],
      icon: <BulletListPoint className="administration-icons" />,
    },
    {
      id: 26,
      name: "User Permission",
      path: "/Administration/User-Permissions",
      rolesCanAccess: ["system admin", "manager", "lead role"],
      icon: <BulletListPoint className="administration-icons" />,
    },
  ],
  "Credit-Control": [
    {
      id: 1,
      name: "Statement Upload",
      path: ROUTES.MUSU,
      rolesCanAccess: [
        "system admin",
        "manager",
        "cc processor",
        "lead role",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    {
      id: 2,
      name: "Uploaded Files",
      path: ROUTES.MUUF,
      rolesCanAccess: [
        "system admin",
        "manager",
        "cc processor",
        "lead role",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    {
      id: 3,
      name: "Bank Statement Transactions",
      path: ROUTES.MUBST,
      rolesCanAccess: [
        "system admin",
        "manager",
        "cc processor",
        "lead role",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    {
      id: 4,
      name: "Allocate Bank Transactions",
      path: ROUTES.MUABT,
      rolesCanAccess: [
        "system admin",
        "lead role",
        "cc processor",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    {
      id: 5,
      name: "Cash Tracker",
      path: ROUTES.MUCASHTRACKER,
      rolesCanAccess: [
        "system admin",
        "manager",
        "cc processor",
        "lead role",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    {
      id: 6,
      name: "Assign Policy Handler",
      path: ROUTES.APH,
      rolesCanAccess: [
        "system admin",
        "manager",
        "cc processor",
        "lead role",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    {
      id: 7,
      name: "Work List Actions",
      path: ROUTES.WLAI,
      rolesCanAccess: [
        "system admin",
        "manager",
        "cc processor",
        "lead role",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    {
      id: 8,
      name: "Bank Reconciliation",
      path: ROUTES.MUBR,
      rolesCanAccess: [
        "system admin",
        "manager",
        "cc processor",
        "lead role",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    // {
    //   id: 9,
    //   name: "Agedebt Calculation",
    //   path: ROUTES.BTAR,
    //   rolesCanAccess: ["system admin", "manager", "cc processor", "lead role", "finance", "treasury"],
    //   icon: <FourSquares />,
    // },
    {
      id: 10,
      name: "Aged Report",
      path: ROUTES.AgedDebtDue,
      rolesCanAccess: [
        "system admin",
        "manager",
        "cc processor",
        "lead role",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    {
      id: 11,
      name: "Query Tracker",
      path: ROUTES.CCC,
      rolesCanAccess: [
        "system admin",
        "manager",
        "cc processor",
        "lead role",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    {
      id: 11,
      name: "Email",
      path: ROUTES.EMAIL,
      rolesCanAccess: [
        "system admin",
        "manager",
        "cc processor",
        "lead role",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    {
      id: 12,
      name: "Workflow Monitoring Dashboard",
      path: ROUTES.WORKFLOWDASHBOARD,
      rolesCanAccess: [
        "system admin",
        "manager",
        "cc processor",
        "lead role",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
  ],
  BDX: [
    {
      id: 1,
      name: "Premium BDX",
      path: ROUTES.PremiumBDX,
      rolesCanAccess: [
        "system admin",
        "manager",
        "lead role",
        "cc processor",
        "quality analyst",
        "lead analyst",
        "onshore lead",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    {
      id: 2,
      name: "Exception Report",
      path: ROUTES.ExceptionReport,
      rolesCanAccess: [
        "system admin",
        "manager",
        "lead role",
        "cc processor",
        "quality analyst",
        "lead analyst",
        "onshore lead",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    {
      id: 3,
      name: "No Var - Pay Release",
      path: ROUTES.PayoutSummary,
      rolesCanAccess: [
        "system admin",
        "manager",
        "lead role",
        "cc processor",
        "quality analyst",
        "lead analyst",
        "onshore lead",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    // {
    //   id: 1,
    //   name: "Treasury",
    //   path: ROUTES.TreasuryList,
    //   rolesCanAccess: ["system admin", "manager", "lead role"],
    //   icon: <FourSquares />,
    // }
  ],
  Treasury: [
    {
      id: 1,
      name: "Payout Summary",
      path: ROUTES.CoversheetList,
      rolesCanAccess: [
        "system admin",
        "manager",
        "lead role",
        "cc processor",
        "quality analyst",
        "lead analyst",
        "onshore lead",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    {
      id: 2,
      name: "Treasury",
      path: ROUTES.TreasuryList,
      rolesCanAccess: [
        "system admin",
        "manager",
        "lead role",
        "cc processor",
        "quality analyst",
        "lead analyst",
        "onshore lead",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
  ],
  Reports: [
    {
      id: 1,
      name: "Cash Tracker",
      path: ROUTES.CASHTRACKER,
      rolesCanAccess: [
        "system admin",
        "manager",
        "lead role",
        "cc processor",
        "quality analyst",
        "lead analyst",
        "onshore lead",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    // {
    //   id: 2,
    //   name: "Summary USD Dashboard",
    //   path: ROUTES.SUD,
    //   rolesCanAccess: [
    //     "system admin",
    //     "manager",
    //     "lead role",
    //     "cc processor",
    //     "quality analyst",
    //     "lead analyst",
    //     "onshore lead",
    //     "finance",
    //     "treasury",
    //   ],
    //   icon: <FourSquares />,
    // },
    {
      id: 2,
      name: "Month End Report",
      path: ROUTES.MER,
      rolesCanAccess: [
        "system admin",
        "manager",
        "lead role",
        "cc processor",
        "quality analyst",
        "lead analyst",
        "onshore lead",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    // {
    //   id: 4,
    //   name: "Overall Reconciliation",
    //   path: ROUTES.OVRRECON,
    //   rolesCanAccess: [
    //     "system admin",
    //     "manager",
    //     "lead role",
    //     "cc processor",
    //     "quality analyst",
    //     "lead analyst",
    //     "onshore lead",
    //     "finance",
    //     "treasury",
    //   ],
    //   icon: <FourSquares />,
    // },
    // {
    //   id: 5,
    //   name: "Commission",
    //   path: ROUTES.COMMISSION,
    //   rolesCanAccess: [
    //     "system admin",
    //     "manager",
    //     "lead role",
    //     "cc processor",
    //     "quality analyst",
    //     "lead analyst",
    //     "onshore lead",
    //     "finance",
    //     "treasury",
    //   ],
    //   icon: <FourSquares />,
    // },
    // {
    //   id: 6,
    //   name: "Amounts By Allocation Status",
    //   path: ROUTES.ABAS,
    //   rolesCanAccess: [
    //     "system admin",
    //     "manager",
    //     "lead role",
    //     "cc processor",
    //     "quality analyst",
    //     "lead analyst",
    //     "onshore lead",
    //     "finance",
    //     "treasury",
    //   ],
    //   icon: <FourSquares />,
    // },
    // {
    //   id: 7,
    //   name: "Amounts By Allocation Status Aging Bucket",
    //   path: ROUTES.ABASAB,
    //   rolesCanAccess: [
    //     "system admin",
    //     "manager",
    //     "lead role",
    //     "cc processor",
    //     "quality analyst",
    //     "lead analyst",
    //     "onshore lead",
    //     "finance",
    //     "treasury",
    //   ],
    //   icon: <FourSquares />,
    // },
    // {
    //   id: 8,
    //   name: "Receivable By Entity",
    //   path: ROUTES.CTABD,
    //   rolesCanAccess: [
    //     "system admin",
    //     "manager",
    //     "lead role",
    //     "cc processor",
    //     "quality analyst",
    //     "lead analyst",
    //     "onshore lead",
    //     "finance",
    //     "treasury",
    //   ],
    //   icon: <FourSquares />,
    // },
    // {
    //   id: 9,
    //   name: "Amounts By Aging Bucket",
    //   path: ROUTES.ABAB,
    //   rolesCanAccess: [
    //     "system admin",
    //     "manager",
    //     "lead role",
    //     "cc processor",
    //     "quality analyst",
    //     "lead analyst",
    //     "onshore lead",
    //     "finance",
    //     "treasury",
    //   ],
    //   icon: <FourSquares />,
    // },
    // {
    //   id: 10,
    //   name: "Amounts By LOB",
    //   path: ROUTES.ABL,
    //   rolesCanAccess: [
    //     "system admin",
    //     "manager",
    //     "lead role",
    //     "cc processor",
    //     "quality analyst",
    //     "lead analyst",
    //     "onshore lead",
    //     "finance",
    //     "treasury",
    //   ],
    //   icon: <FourSquares />,
    // },
    // {
    //   id: 11,
    //   name: "Write-off",
    //   path: ROUTES.RWF,
    //   rolesCanAccess: [
    //     "system admin",
    //     "manager",
    //     "lead role",
    //     "cc processor",
    //     "quality analyst",
    //     "lead analyst",
    //     "onshore lead",
    //     "finance",
    //     "treasury",
    //   ],
    //   icon: <FourSquares />,
    // },
    // {
    //   id: 12,
    //   name: "Refund Report",
    //   path: ROUTES.RD,
    //   rolesCanAccess: [
    //     "system admin",
    //     "manager",
    //     "lead role",
    //     "cc processor",
    //     "quality analyst",
    //     "lead analyst",
    //     "onshore lead",
    //     "finance",
    //     "treasury",
    //   ],
    //   icon: <FourSquares />,
    // },
    // {
    //   id: 13,
    //   name: "Amounts By Correction Type",
    //   path: ROUTES.ABCT,
    //   rolesCanAccess: [
    //     "system admin",
    //     "manager",
    //     "lead role",
    //     "cc processor",
    //     "quality analyst",
    //     "lead analyst",
    //     "onshore lead",
    //     "finance",
    //     "treasury",
    //   ],
    //   icon: <FourSquares />,
    // },
    // {
    //   id: 14,
    //   name: "Corrective Transfers",
    //   path: ROUTES.CT,
    //   rolesCanAccess: [
    //     "system admin",
    //     "manager",
    //     "lead role",
    //     "cc processor",
    //     "quality analyst",
    //     "lead analyst",
    //     "onshore lead",
    //     "finance",
    //     "treasury",
    //   ],
    //   icon: <FourSquares />,
    // },
    // {
    //   id: 15,
    //   name: "Cross Allocation Report",
    //   path: ROUTES.CAR,
    //   rolesCanAccess: [
    //     "system admin",
    //     "manager",
    //     "lead role",
    //     "cc processor",
    //     "quality analyst",
    //     "lead analyst",
    //     "onshore lead",
    //     "finance",
    //     "treasury",
    //   ],
    //   icon: <FourSquares />,
    // },
    // {
    //   id: 16,
    //   name: "CFI",
    //   path: ROUTES.CFI,
    //   rolesCanAccess: [
    //     "system admin",
    //     "manager",
    //     "lead role",
    //     "cc processor",
    //     "quality analyst",
    //     "lead analyst",
    //     "onshore lead",
    //     "finance",
    //     "treasury",
    //   ],
    //   icon: <FourSquares />,
    // },
    // {
    //   id: 17,
    //   name: "Current Month Allocation Non-SCM",
    //   path: ROUTES.CMA,
    //   rolesCanAccess: [
    //     "system admin",
    //     "manager",
    //     "lead role",
    //     "cc processor",
    //     "quality analyst",
    //     "lead analyst",
    //     "onshore lead",
    //     "finance",
    //     "treasury",
    //   ],
    //   icon: <FourSquares />,
    // },
    // {
    //   id: 18,
    //   name: "Correction Types",
    //   path: ROUTES.MUCT,
    //   rolesCanAccess: [
    //     "system admin",
    //     "manager",
    //     "lead role",
    //     "cc processor",
    //     "quality analyst",
    //     "lead analyst",
    //     "onshore lead",
    //     "finance",
    //     "treasury",
    //   ],
    //   icon: <FourSquares />,
    // },
    {
      id: 3,
      name: "Age Profile",
      path: "/Reports/Age-Profile",
      rolesCanAccess: [
        "system admin",
        "manager",
        "lead role",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    {
      id: 4,
      name: "Cash Receivable",
      path: "/Reports/Cash-Receivable---In-Prod-Test",
      rolesCanAccess: [
        "system admin",
        "manager",
        "lead role",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    {
      id: 5,
      name: "Allocation Trend Report",
      path: "/Reports/Allocation-Trend-Report---Prod-Test-",
      rolesCanAccess: [
        "system admin",
        "manager",
        "lead role",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    {
      id: 6,
      name: "Partner Profile",
      path: "/Reports/Partner-Profile",
      rolesCanAccess: [
        "system admin",
        "manager",
        "lead role",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
    {
      id: 7,
      name: "Aging Bucket",
      path: "/Reports/Aging-Bucket",
      rolesCanAccess: [
        "system admin",
        "manager",
        "lead role",
        "finance",
        "treasury",
      ],
      icon: <FourSquares />,
    },
  ],

  // Dashboard: [
  //   {
  //     id: 1,
  //     name: "Dashboard",
  //     path: ROUTES.Dashboard,
  //     rolesCanAccess: ["system admin", "manager", "lead role"],
  //     icon: <FourSquares />,
  //   }
  // ],
};
